import { render, staticRenderFns } from "./jxgl.vue?vue&type=template&id=70cb7a63&"
import script from "./jxgl.vue?vue&type=script&lang=ts&"
export * from "./jxgl.vue?vue&type=script&lang=ts&"
import style0 from "./jxgl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports